import axios from '../../service/index'
import React, { Component } from 'react'
import {connect} from "react-redux";
import { Button, Divider, message, Form, Input} from 'antd'
import 'highlight.js/styles/monokai-sublime.css'
import './typetopic.less'
import Wangeditor from '../../commponents/wangeditor/index'
const FormItem = Form.Item
const { TextArea } = Input;
// const qiniuUpUrl = 'https://up-z1.qiniup.com'
class Interview extends Component {
  state = {
    modelTitle: '新增知识点',
    typeQ: 'add', // 传过来的新增还是编辑
    editor: '',
    editorHtml: '',
		editorText: '',
    contentObj: {
      type: '1',
      content: '',
      analysis: ''
    },
    knowId: '',
    questionId: '',
    token: '',
    url: '',
    typebtn: '',
    interviewId: '',
    subjectName: '',
    pageNum: 1,
    plainOptions: []
  }
  submitOk = (e) => {
    e.preventDefault();
    let {form} = this.props
    let {knowId, questionId, typebtn, subjectName, interviewId,typeQ, pageNum} = this.state
    form.validateFields((err, values) => {
      if(!err) {
        // console.log(values)
        let obj = {...values, type: 2,konwledgeId: knowId,subjectId: questionId}
        if(typeQ === 'edit'){
          obj.id = interviewId
        }else{
          delete obj.id
        }
        let url = this.state.typeQ === 'add' ? '/question/save' : '/question/update'
        axios.post(url, obj).then(res => {
          if(res.data.code !== '200') return message.error(res.data.msg)
          message.success(`${this.state.typeQ === 'add'?'新增':'修改'}成功`)
          form.resetFields();
          //this.state.editor.txt.html('<p><br></p>')
          if(typebtn === 'save'){
            this.props.backTabButton('2')
            this.props.history.push('/Test',{knowId, questionId, subjectName, pageNum})
          }
        })
      }
    })
  }

  saveLinkbtn = () => {
    this.setState({typebtn: 'save'})
  }
  cancelbtn = () => {
    let {knowId, questionId, subjectName, pageNum} = this.state
    this.props.backTabButton('2')
    this.props.form.resetFields();
    this.props.history.push('/Test',{knowId, questionId, subjectName, pageNum})
    
  }
  getToken=() =>{
		let _this = this;
		axios.get("/uplodController/get7menrToken").then((res) => {
			if (res.data.code === '200') {
				_this.setState({
					token: res.data.data.token,
					url: res.data.data.url
				})
			} else {
				message.error('七牛token获取失败')
			}

		}).catch((e) => {
			console.log(e)
		})
	}
  componentWillUnmount() {
    this.setState({typebtn: ''})
  }
  componentDidMount() {
    this.getToken()
    let {knowId, questionId, interviewId, subjectName, pageNum, typeQ} = this.props.location.state
    this.setState({knowId,questionId, interviewId, subjectName, pageNum, typeQ},() => {
      if(this.state.typeQ === 'edit'){
        this.getQuestionInfo()
      }
    })
  //   let editor = new E(ReactDOM.findDOMNode(this._div))
	// 	this.setState({ editor: editor })
	// 	editor.config.menus = [
	// 		'head',
	// 		'bold',
	// 		'fontSize',
	// 		'fontName',
	// 		'italic',
	// 		'underline',
	// 		'strikeThrough',
	// 		'indent',
	// 		'lineHeight',
	// 		'foreColor',
	// 		'backColor',
	// 		'link',
	// 		'list',
	// 		'todo',
	// 		'justify',
	// 		'quote',
	// 		'emoticon',
	// 		'image',
	// 		'video',
	// 		'table',
	// 		'code',
	// 		'splitLine',
	// 		'undo',
	// 		'redo',
	// 	]
	// 	editor.config.languageType = [
	// 		'Bash',
	// 		'C',
	// 		'C#',
	// 		'C++',
	// 		'CSS',
	// 		'Java',
	// 		'JavaScript',
	// 		'JSON',
	// 		'TypeScript',
	// 		'Plain text',
	// 		'Html',
	// 		'XML',
	// 		'SQL',
	// 		'Go',
	// 		'Kotlin',
	// 		'Lua',
	// 		'Markdown',
	// 		'PHP',
	// 		'Python',
	// 		'Shell Session',
	// 		'Ruby',
	// 	]
  //   editor.config.uploadImgMaxLength = 5;
	// 	editor.config.showLinkImg = false;
	// 	editor.config.uploadImgServer = "/upload"; //上传图片的server接口地址
	// 	editor.config.withCredentials = false;
	// 	editor.config.uploadImgTimeout = 5 * 1000;
  //   let _this = this
  //   editor.config.customUploadImg = function (resultFiles, insertImgFn) {
  //     console.log(resultFiles)
	// 		let imgUrl = ''
	// 		let data = new FormData();
	// 		data.append("token", _this.state.token);
	// 		data.append("file", resultFiles[0]);
	// 		axios({
	// 			method: "POST",
	// 			url: qiniuUpUrl,
	// 			data: data,
	// 			onUploadProgress: function (progressEvent) {
	// 			},
	// 		}).then((res) => {
	// 			imgUrl = _this.state.url + '/' + res.data.key
	// 			insertImgFn(imgUrl);
	// 		});
	// 	};
  //   editor.config.onchange = (html) => {
	// 		this.setState({
	// 			editorHtml: html,
	// 			editorText: editor.txt.text()
	// 		})
	// 		//将html值设为form表单的desc属性值
	// 		this.props.form.setFieldsValue({
	// 			'analysis': html
	// 		});
	// 	}
	// editor.highlight = hljs
  //   editor.create()

    // console.log(this.state.typeQ)
    
  }
  getQuestionInfo = () => {
    let {interviewId} = this.props.location.state
    axios.get(`/question/info/${interviewId}`).then(res => {
      if (res.data.code === '200') {
        let data = res.data.data
        this.setState({contentObj: {content: data.content, analysis: data.analysis}})
       // this.state.editor.txt.html(data.analysis)
      }
    })
  }
  getText = v => {
    // console.log(v)
     this.props.form.setFieldsValue({
       'content': v
     });
   }
   getAnalysis= v => {
     //console.log(v)
     this.props.form.setFieldsValue({
       'analysis': v
     });
   }
  render() {
    let { typeQ, knowId, questionId, subjectName} = this.state
    let {content,analysis} = this.state.contentObj
    const tailLayout = {
      wrapperCol: { offset: 2, span: 12 },
    }
    const { getFieldDecorator } = this.props.form;
    return (
      <div className="topic interview">
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
					<span className="topic-title">{typeQ === 'add' ? '新增' : '编辑'}试题</span>
					<span className="my-button-txt" onClick={() => {
            this.props.backTabButton('2')
            this.props.history.push('/Test',{knowId, questionId, subjectName})
					}}>返回上一级</span>
				</div>
				<Divider />
          <Form labelCol={{ span: 2 }} wrapperCol={{ span: 12 }} onSubmit={this.submitOk}>
            <FormItem label="题干" name="content">
              {getFieldDecorator('content', {
              rules: [
                {required: true,message: '请输入题干'},
                {max: 500,message: '最多输入500个字!'}
              ],
              initialValue: typeQ === 'edit'? content: ''
              })(<TextArea rows={4} maxLength="500" />)}
						</FormItem>
             {/* <FormItem label="题干" name="content">
              {getFieldDecorator('content', {
                rules: [
                  {required: true,message: '请输入题干'},
                  {max: 500,message: '最多输入500个字!'}
                ],
                initialValue: typeQ === 'edit' && content ? content : ''
              })(
                // <div ref={(ref) => this._div = ref}></div>
                <Wangeditor content={content}  getText={this.getText}/>
              )}
              </FormItem> */}
            <FormItem label="答案解析：" name="analysis">
              {getFieldDecorator('analysis', {
                initialValue: this.state.typeQ === 'edit' && analysis ? analysis : ''
              })(
                // <div ref={(ref) => this._div = ref}></div>
                <Wangeditor content={analysis}  getText={this.getAnalysis}/>
              )}
            </FormItem>
            <FormItem {...tailLayout}>
              <Button onClick={this.cancelbtn}>
                取消
              </Button>
              <Button type="primary" className="mar-btn" onClick={this.saveLinkbtn} htmlType="submit">
                保存
              </Button>
              <Button style={{display:this.state.typeQ === 'add'?'block':'none'}} type="primary" htmlType="submit">
                保存并继续添加
              </Button>
            </FormItem>
					</Form>
      </div>
    )
  }
}
const mapDispatchToProps = (dispatch) => {
  return {
    backTabButton(num) {
       let action = {
        type: 'tabChange',
        value: num
      }
      dispatch(action)
    }
  }
}
export default Form.create()(connect(null, mapDispatchToProps)(Interview))